export default {"src":"/_next/static/media/aadharkyc.ffc830de.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};